import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LocalAccessHubsPage from './pages/LocalAccessHubsPage';
import OfflineResourcesPage from './pages/OfflineResourcesPage';
import PhoneAlertsPage from './pages/PhoneAlertsPage';
import CommunityForumPage from './pages/CommunityForumPage';
import TransparencyDashboardPage from './pages/TransparencyDashboardPage';
import AboutUsPage from './pages/AboutUsPage';
import ContactPage from './pages/ContactPage';
import AddNewHub from './pages/AddNewHub';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import { useUser } from './UserContext';
import Login from './pages/Login';
import GeminiApi from './gemini/GeminiApi';
import ForignProfile from './pages/ForignProfile';

export default function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const mainContentRef = useRef(null);
  const location = useLocation();
const {currentUser} = useUser()
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 font-sans bg-gradient-to-br from-green-50 to-green-300">
      {location.pathname !== '/gemini'&&location.pathname !== '/login' && <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />}
      
      <main ref={mainContentRef} className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hubs" element={<LocalAccessHubsPage />} />
          <Route path="/resources" element={<OfflineResourcesPage />} />
          <Route path="/alerts" element={<PhoneAlertsPage />} />
          <Route path="/forum" element={<CommunityForumPage />} />
          <Route path="/dashboard" element={<TransparencyDashboardPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/add-new-hub" element={<AddNewHub />} />
          <Route path="/profile" element={currentUser?<Profile />:<HomePage/>} />
          <Route path="/forign-profile/:id" element={<ForignProfile />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/gemini" element={<GeminiApi />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      
      {location.pathname !== '/forum' && location.pathname !== '/gemini'&& <Footer />}
    </div>
  );
}


